/**
 * 友盟，站长统计
 */
 let statisticsType = {
	enter: '进入专区',
	joinCart: '加入购物车',
	orderBuy: '订单支付'
}
const statisticsApi = {
	/**
	 * 发送页面上按钮等交互元素被触发时的事件统计请求
	 *  @param {String} type 统计类型 joinCart加入购物车 orderBuy订单支付
	 * 	@param {Object} parasm 附带自定义参数
	 */
	trackEvent: (type, parasm = '') => {
		if (_czc) {
			_czc.push(['_trackEvent', '礼包pc', statisticsType[type], parasm])
		}
	}
}
export default statisticsApi
